
var ScanbotSDK = module.exports = require("./bundle/ScanbotSDK.min.js").ScanbotSDK;
